import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=e4d7a17a&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4d7a17a')) {
      api.createRecord('e4d7a17a', component.options)
    } else {
      api.reload('e4d7a17a', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=e4d7a17a&", function () {
      api.rerender('e4d7a17a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8MyGEUGugyupz/JS/pricehelp.vue"
export default component.exports